<form [formGroup]="baseFormGroup" #f="ngForm" class="mt-4 pl-2">
    <div class="form-horizontal">
        <div class="form-group row">
            <div class="col-md-12">
                <yt-dropdown-picklist
                    [ModelName]="'podvrstadokumentastavka'"
                    [GetName]="'GetByUrl'"
                    [ModelProperty]="'Sifra,Naziv'"
                    [GetParameters]="[{ Name: 'url', Value: '/kad/angazovanjeroresenje' }]" [OrderBy]="'Naziv'" [AllowAddNew]="false"
                    formControlName="PodvrstaDokumentaStavkaID"
                    [Label]="'ANGAZOVANJERO.PODVRSTADOKUMENTASTAVKA.SINGULAR'"
                    (OnItemSelected)="onPodvrstaDokumentaStavkaSelected($event)">
                </yt-dropdown-picklist>
            </div>
        </div>

        <div class="form-group row">
            <div class="col-md-4">
                <yt-fw-date-picker-popup
                    formControlName="Datum" name="txtDatum" [Label]="'DOKUMENT.DATUM.SINGULAR'"
                    [ngClass]="{'is-invalid': submitted && fc.Datum.invalid}"
                    (OnDateSelected)="onDatumChange($event)">
                </yt-fw-date-picker-popup>
            </div>
            <div class="col-md-4">
                <div class="input-group">
                    <yt-input [Type]="'text'" [Label]="'ANGAZOVANJERO.BROJ.SINGULAR'" formControlName="Broj" [ngClass]="{'is-invalid': submitted && fc.Broj.invalid}">
                    </yt-input>
                    <!-- <div class="input-group-append">
              <span class="span-control">/</span><span *ngIf="baseFormGroup.get('Datum').value != null" class="span-control">{{baseFormGroup.get('Datum').value.year}}</span>
            </div> -->
                </div>
            </div>

            <div class="col-md-4">
                <yt-fw-date-picker-popup name="txtOdDatuma" formControlName="OdDatuma" [ngClass]="{'is-invalid' : submitted && fc.OdDatuma.invalid}"
                    [Label]="'ANGAZOVANJERO.ODDATUMA.SINGULAR'">
                </yt-fw-date-picker-popup>
                <div class="form-error" *ngIf="submitted && fc.OdDatuma.invalid">
                    <span *ngFor="let validation of errorMessages.OdDatuma">
                        <span class="error-message" *ngIf="fc.OdDatuma.hasError(validation.type)"><span translate="{{validation.message}}"></span></span>
                    </span>
                </div>
            </div>        
        </div>
        <div class="form-group row" *ngIf="editMode">
            <div class="col-md-12">
                <yt-dropdown-picklist [ModelName]="'osoba'" [GetName]="'get'" [ModelProperty]="'Prezime,Ime,Jmbg'"
                    [OrderBy]="'Prezime'" formControlName="OsobaID" [AllowAddNew]="false" [Label]="'ANGAZOVANJERO.OSOBA.SINGULAR'">
                </yt-dropdown-picklist>
            </div>
        </div>
        <div class="form-group row" *ngIf="!editMode">
            <div class="col-md-12">
                <yt-dropdown-picklist [ModelName]="'zaposleni'" [GetName]="'get'" [ModelProperty]="'Prezime,Ime,Jmbg'"
                    [OrderBy]="'Prezime'" formControlName="OsobaID" [AllowAddNew]="false" [Label]="'ANGAZOVANJERO.OSOBA.SINGULAR'">
                </yt-dropdown-picklist>
            </div>
        </div>

        
        <div class="form-group row">
            <div class="col-md-12">
                <yt-dropdown-picklist [ModelName]="'angazovanjero'" [GetName]="'get'" [ModelProperty]="'Broj'"
                    [OrderBy]="'Broj'" [AllowAddNew]="false" formControlName="TataID" [Label]="'ANGAZOVANJERO.TATAID.SINGULAR'">
                </yt-dropdown-picklist>
            </div>
        </div>
        <div class="form-group row">
            <div class="col-md-12">
                <yt-dropdown-picklist [ModelName]="'razlogprestankaro'" [GetName]="'get'" [ModelProperty]="'Naziv'"
                    [OrderBy]="'Naziv'" [AllowAddNew]='true' formControlName="RazlogPrestankaRoID" [Label]="'ANGAZOVANJERO.RAZLOGPRESTANKARO.SINGULAR'">
                </yt-dropdown-picklist>
                <div class="form-error" *ngIf="submitted && fc.RazlogPrestankaRoID.invalid">
                    <span *ngFor="let validation of errorMessages.RazlogPrestankaRoID">
                        <span class="error-message" *ngIf="fc.RazlogPrestankaRoID.hasError(validation.type)"><span
                                translate="{{validation.message}}"></span></span>
                    </span>
                </div>
            </div>
        </div>
    </div>

</form>